import { useAppConfigContext } from '@vivli/core/infrastructure/context';
import { useDefaultRoutes, useResultRequestRoutes } from '../routes';
import { RouteObject } from 'react-router';
import { useEffect, useState } from 'react';

export const useRoutesInit = (): RouteObject[] => {
    const appConfig = useAppConfigContext();
    const [routes, setRoutes] = useState<RouteObject[]>();

    const defaultRoutes = useDefaultRoutes();
    const resultRequestRoutes = useResultRequestRoutes();

    useEffect(() => {
        const routesToUse = appConfig?.viewRequestResultsOnly ? resultRequestRoutes : defaultRoutes;
        setRoutes(routesToUse);

        //the export-results app needs the platform's 1320px body floor relaxed so it fits a research
        //environment window; styles.scss keys that off this class. (DEV-743)
        document.body.classList.toggle('request-results-only', !!appConfig?.viewRequestResultsOnly);
    }, [appConfig?.viewRequestResultsOnly]);

    return routes;
};
